import _ from 'lodash'

const getBatteryStatus = (battery, isNotPercent = false) => {

  let batteryPercent

  if (isNotPercent) {
    batteryPercent = battery
  } else {
    batteryPercent = parseInt(battery * 100, 10)
  }

  let color = ""
  let icon  = ""

  if (_.inRange(batteryPercent, 0, 10)) {
    icon  = "battery empty"
    color = "red"
  } else if (_.inRange(batteryPercent, 10, 20)) {
    icon  = "battery quarter"
    color = "red"
  } else if (_.inRange(batteryPercent, 20, 40)) {
    icon  = "battery quarter"
    color = "orange"
  } else if (_.inRange(batteryPercent, 40, 60)) {
    icon  = "battery half"
    color = "orange"
  } else if (_.inRange(batteryPercent, 60, 90)) {
    icon  = "battery three quarters"
    color = "olive"
  } else if (_.inRange(batteryPercent, 90, 100)) {
    icon  = "battery full"
    color = "green"
  } else if (batteryPercent === 100) {
    icon  = "battery full"
    color = "green"
  } else {
    icon  = "battery empty"
    color = "red"
  }

  return ({
    color,
    icon
  })
}

export default getBatteryStatus


// WEBPACK FOOTER //
// ./src/helpers/BatteryStatus.js